import { __awaiter } from 'tslib';
import { useState, useCallback } from 'react';
import '../../services/base/baseDiscoverService.js';
import '../../services/base/baseV3Service.js';
import '../../services/base/baseInsightsService.js';
import '../../services/sgtService.js';
import '@analytics/storage-utils';
import 'date-fns/format';
import 'date-fns/secondsToMinutes';
import 'date-fns/isValid';
import 'date-fns/addMinutes';
import 'date-fns';
import 'date-fns-tz';
import '../../utils/ErrorProvider.js';
import '../../utils/LoaderProvider.js';
import '../../utils/RefetchProvider.js';
import '../../utils/NotificationProvider.js';
import '../../utils/ContactProvider.js';
import '../../utils/PolicyProvider.js';
import '../../utils/AnalyticsProvider.js';
import '../../types/AccessDevice.js';
import '../../types/Analytics.js';
import '../../types/CASACommunity.js';
import '../../types/Community.js';
import '../../types/DxSettings.js';
import '../../types/MagicButton.js';
import '../../types/Pannellum.js';
import '../../types/Prospect.js';
import '../../types/ProspectIntelligence.js';
import '../../types/Space.js';
import '../../types/Tour.js';
import '../../utils/analyticsPlugin.js';
import '../../utils/communityGoogleAnalyticsPlugin.js';
import 'qs';
import '../../utils/cookieUtils.js';
import '../../utils/termsConditionsAgreementsUtils.js';
import '../../services/base/analyticsV2BaseService.js';
import 'axios';
import '../../services/base/internalApiBaseService.js';
import '../../services/base/casaBaseService.js';
import '../../services/scanRequestsService.js';
import '../../services/db/insightsReportsDB.js';
import { getAssessmentTemplateTrackedCompetitors } from '../../services/aiDiscoverability.js';

const useGetAssessmentTemplateTrackedCompetitors = () => {
    const [trackedCompetitors, setTrackedCompetitors] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const api = useCallback((subjectId) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        try {
            setLoading(true);
            setError(null);
            setTrackedCompetitors(null);
            const response = yield getAssessmentTemplateTrackedCompetitors(subjectId);
            setTrackedCompetitors((_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.trackedCompetitors) !== null && _b !== void 0 ? _b : []);
        }
        catch (error) {
            setError(error);
        }
        finally {
            setLoading(false);
        }
    }), []);
    return [api, trackedCompetitors, loading, error];
};

export { useGetAssessmentTemplateTrackedCompetitors };
